export const VOUCHER_UPDATE_FORM_ID = Symbol();
